<app-navbar title="Mapa">
	<span *ngIf="vehicleSelected">
		<span class="btn btn-outline-light me-4">
			<i class="fas fa-bus"></i>
			{{ vehicleSelected?.name }}
		</span>
		<span class="btn btn-outline-light me-4">
			<i class="fas fa-users"></i>
			{{ vehicleSelected?.seats - vehicleSelected?.occupied - vehicleSelected?.crew }}
		</span>
	</span>
	<button class="btn btn-warning me-4" (click)="resetAsk()"><i class="fas fa-retweet"></i> Resetuj</button>
	<button class="btn btn-secondary me-4" (click)="undo()">
		<i class="fas fa-undo"></i>
		Cofnij
	</button>
	<button class="btn btn-secondary me-4" (click)="generateConnectionsAll()">
		<i class="fas fa-network-wired"></i>
		Wszystkie połączenia
	</button>
	<button class="btn btn-success me-4" (click)="showVehicles = !showVehicles">
		<i class="fas fa-bus"></i> Pojazdy
	</button>
	<a class="btn btn-primary me-4" routerLink="/tourism-transport-list/{{ timetable.id }}">
		<i class="fas fa-list"></i> Listy
	</a>
	<a class="btn btn-primary me-4" routerLink="/tourism-timetable/{{ timetable.id }}">
		<i class="far fa-clock"></i> Godziny
	</a>
	<button class="btn btn-danger me-4" (click)="edit()" *ngIf="!editable"><i class="fas fa-check"></i> Edytuj</button>
	<button class="btn btn-success me-4" (click)="save()" *ngIf="editable"><i class="fas fa-check"></i> Zapisz</button>
	<a class="btn btn-warning me-2" routerLink="/timetable/{{ timetable.id }}">
		<i class="fas fa-radiation"></i> Podstawowe
	</a>
</app-navbar>
<ol class="breadcrumb">
	<li class="breadcrumb-item fw-bolder">{{ timetable?.sideName }}</li>
	<li class="breadcrumb-item" *ngFor="let item of timetable?.destinations">
		{{ item.destinationName }}
		<span *ngIf="timetable.side === 'departure'">({{ item.departureDate }} {{ item.accommodationFrom }})</span>
		<span *ngIf="timetable.side === 'return'"
			>({{ item.departureFromDestination }} {{ item.arrivalToLastStop }})</span
		>
	</li>
</ol>

<div class="alert alert-danger" *ngIf="editable">
	<p>Pozostały czas: {{ lockTimerText }}</p>
	<button class="btn btn-light" (click)="edit()">Odśwież</button>
</div>

<app-tourism-map-transport
	*ngIf="showVehicles"
	[vehiclesAll]="vehiclesAll"
	[editable]="editable"
	[(vehicles)]="vehicles"
	(selected)="vehicleSelect($event)"
></app-tourism-map-transport>

<app-tourism-map-people
	[editable]="editable"
	[(city)]="citySelected"
	[(vehicle)]="vehicleSelected"
	(closed)="mapPeopleClose()"
></app-tourism-map-people>

<div
	class="line"
	style="left: {{ conn.x }}px; top:{{ conn.y }}px; width:{{ conn.length }}px; transform:rotate({{ conn.angle }}deg);"
	*ngFor="let conn of connections"
></div>

<div id="tooltip" *ngIf="tooltip.x && tooltip.y" style="left: {{ tooltip.x }}px; top:{{ tooltip.y }}px">
	<table class="table table-striped">
		<thead>
			<tr>
				<th>Cel</th>
				<th>Rezerwacja</th>
				<th>Osób</th>
				<th>Opcja</th>
				<th>Kwota</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let reservation of tooltip.data?.reservations">
				<td>{{ reservation.destinationName }}</td>
				<td>
					{{ reservation.number }}
					<i
						class="fas fa-exclamation-triangle text-warning"
						*ngIf="reservation.warning"
						[matTooltip]="reservation.warning"
					></i>
				</td>
				<td>{{ reservation.people }}</td>
				<td><span *ngIf="reservation.option">Opcja</span></td>
				<td>{{ reservation.amount }}</td>
			</tr>
		</tbody>
	</table>
</div>

<div class="row" *ngFor="let row of map">
	<div class="col-sm" *ngFor="let pos of row">
		<div
			class="pos city btn btn-outline-secondary"
			id="{{ 'city' + pos.id }}"
			*ngIf="pos.name"
			[ngClass]="{ 'btn-outline-danger': pos.primary }"
			(mouseover)="showTooltip(pos)"
			(mouseout)="showTooltip(false)"
			(click)="citySelect(pos)"
			[attr.disabled]="!vehicleSelected"
		>
			<b>{{ pos.code }}</b
			><br />
			<span *ngIf="pos.people > 0">
				{{ pos.assigned }} /
				{{ pos.people }}
				({{ pos?.options }})<br />
				R-{{ pos?.reservations?.length }}
			</span>
		</div>
		<div class="pos" *ngIf="!pos.name"></div>
	</div>
</div>

<div class="container pb-4 text-center">
	<div
		class="btn btn-lg btn-danger me-4"
		*ngFor="let pos of destinations"
		(click)="endTrip(pos)"
		id="city{{ pos.stopTo }}"
	>
		<b>{{ pos.name }}</b>
	</div>
</div>
